// src/locales/ta/userRoles.js
export const userRoles = {
    createNewRole: "புதிய பயனர் பங்கு உருவாக்கு",
    definePermissions: "குழு உறுப்பினர்களுக்கான அனுமதிகள் மற்றும் அணுகல் நிலைகளை வரையறுக்கவும்",
    basicInformation: "அடிப்படை தகவல்",
    provideBasicDetails: "பங்கு பற்றிய அடிப்படை விவரங்களை வழங்கவும்",
    roleName: "பங்கு பெயர்",
    roleNamePlaceholder: "பங்கு பெயரை உள்ளிடுங்கள் (எ.கா: மேலாளர், ஊழியர்)",
    description: "விளக்கம்",
    descriptionPlaceholder: "இந்த பங்கு மற்றும் அதன் பொறுப்புகள் பற்றிய விருப்ப விளக்கம்...",
    descriptionHint: "மற்றவர்கள் இந்த பங்கின் நோக்கத்தைப் புரிந்துகொள்ள உதவும் சுருக்கமான விளக்கம் கொடுங்கள்",
    permissions: "அனுமதிகள்",
    selectPermissions: "இந்த பங்கு செய்யக்கூடிய செயல்களைத் தேர்ந்தெடுக்கவும்",
    selected: "தேர்ந்தெடுக்கப்பட்டது",
    total: "மொத்தம்",
    loadingPermissions: "அனுமதிகள் ஏற்றப்படுகின்றன...",
    loadingPermissionsDesc: "கிடைக்கும் அனுமதிகளை நாங்கள் பெறும்போது தயவுசெய்து காத்திருங்கள்.",
    roleNameRequired: "பங்கு பெயர் தேவை",
    roleNameMinLength: "பங்கு பெயர் குறைந்தது 2 எழுத்துகளாக இருக்க வேண்டும்",
    selectAtLeastOne: "தயவுசெய்து குறைந்தது ஒரு அனுமதியைத் தேர்ந்தெடுக்கவும்",
    roleCreatedSuccess: "\"{{roleName}}\" பங்கு வெற்றிகரமாக உருவாக்கப்பட்டது!",
    failedToCreate: "பங்கு உருவாக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    failedToLoadPermissions: "அனுமதிகளை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    backToRoles: "பங்குகளுக்கு திரும்பு",
    createRole: "பங்கு உருவாக்கு",
    manageUserRoles: "உங்கள் குழுவிற்கான பயனர் பங்குகள் மற்றும் அனுமதிகளை நிர்வகிக்கவும்",
    loadingRoles: "பங்குகள் ஏற்றப்படுகின்றன...",
    loadingRolesDesc: "பயனர் பங்குகளை நாங்கள் பெறும்போது தயவுசெய்து காத்திருங்கள்.",
    searchRoles: "பெயர் அல்லது விளக்கத்தின் மூலம் பங்குகளைத் தேடுங்கள்...",
    searchResults: "{{total}} இல் {{count}} பங்குகள்",
    totalRoles: "{{count}} பங்குகள்",
    noSearchResults: "பங்குகள் கிடைக்கவில்லை",
    noSearchResultsDesc: "உங்கள் தேடல் சொற்களை சரிசெய்ய முயற்சிக்கவும் அல்லது அனைத்து பங்குகளையும் பார்க்க தேடலை அழிக்கவும்.",
    clearSearch: "தேடலை அழி",
    noRoles: "இன்னும் பயனர் பங்குகள் இல்லை",
    noRolesDesc: "குழு அனுமதிகளை நிர்வகிக்கத் தொடங்க உங்கள் முதல் பயனர் பங்கை உருவாக்கவும்.",
    createFirstRole: "முதல் பங்கை உருவாக்கு",
    noDescription: "விளக்கம் வழங்கப்படவில்லை",
    moreActions: "மேலும் செயல்கள்",
    confirmDelete: "'{{roleName}}' பங்கை நீக்க விரும்புகிறீர்களா? இந்த செயலை மாற்ற முடியாது.",
    roleDeletedSuccess: "'{{roleName}}' பங்கு வெற்றிகரமாக நீக்கப்பட்டது.",
    failedToDelete: "பங்கை நீக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    retry: "மீண்டும் முயற்சிக்கவும்",
    editRole: "பயனர் பங்கை திருத்து",
    updatePermissions: "இந்த பங்கிற்கான அனுமதிகள் மற்றும் அணுகல் நிலைகளை புதுப்பிக்கவும்",
    updateBasicDetails: "பங்கு பற்றிய அடிப்படை விவரங்களை புதுப்பிக்கவும்",
    loadingRole: "பங்கு ஏற்றப்படுகிறது...",
    loadingRoleDesc: "பங்கு தரவைப் பெறும்போது தயவுசெய்து காத்திருங்கள்.",
    roleNotFound: "பங்கு கிடைக்கவில்லை. அது நீக்கப்பட்டிருக்கலாம்.",
    failedToLoadRole: "பங்கு தரவை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    noChangesToSave: "சேமிக்க எந்த மாற்றங்களும் செய்யப்படவில்லை.",
    roleUpdatedSuccess: "'{{roleName}}' பங்கு வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
    failedToUpdate: "பங்கை புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    confirmDiscardChanges: "உங்களிடம் சேமிக்கப்படாத மாற்றங்கள் உள்ளன. சேமிக்காமல் வெளியேற விரும்புகிறீர்களா?",
    updateRole: "பங்கை புதுப்பி",
    noChanges: "மாற்றங்கள் இல்லை",
    unsavedChanges: "சேமிக்கப்படாத மாற்றங்கள்",
    discardChanges: "மாற்றங்களை நிராகரி",
    systemRole: "அமைப்பு பங்கு",
    confirmDuplicate: "'{{roleName}}' இன் நகலை உருவாக்கவா?",
    roleDuplicatedSuccess: "'{{roleName}}' பங்கு வெற்றிகரமாக நகலெடுக்கப்பட்டது!",
    failedToDuplicate: "பங்கை நகலெடுக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    cannotDeleteRoleWithUsers: "பங்கை நீக்க முடியாது. பயனர்கள் இந்த பங்கிற்கு ஒதுக்கப்பட்டுள்ளனர்."
}